YUI.add('more-toggle', function (Y) {

/*
 *
 * Initial HTML:
 *
 * <div class="ksu-more-container-tab">
 * ...content to be clipped...
 * </div>
 *
 * or
 *
 * <div class="ksu-more-container-arrow">
 * ...content to be clipped...
 * </div>
 *
 * becomes:
 *
 * <div class="ksu-more-container-tab">
 *     <div class='ksu-more-toggle'>
 *         <div class='ksu-more-icon'>+ show more</div>
 *         <div class='ksu-more-line'></div>
 *     </div>
 *     <div class='ksu-more-content">
 *         ...content to be clipped...
 *     </div>
 * </div>
 *
 */

"use strict";

var HOST = "host",
    DOT = ".",
    REGION = "region",
    CLASS = "class",
    HEIGHT = "height",
    HEIGHT_CLOSED = "36px",  /* Should match the height of .ksu-more-container-arrow in the CSS. */
    TRANSITION_DURATION = 0.5,

    /*
     * Constants used as attribute names used to store information on this plugin instance. There is one
     * constant here for each attribute defined in the MoreToggle.ATTRS property.
     */
    CONTAINER_TAB_CLASS_KEY = "containerTabClass",
    CONTAINER_ARROW_CLASS_KEY = "containerArrowClass",
    CONTAINER_SELECTOR_KEY = "containerSelector",
    TAB_FORMAT_CLASS_KEY = "tabFormatClass",
    TRIGGER_CLASS_KEY = "triggerClass",
    OPEN_CLASS_KEY = "openClass",
    CONTENT_CLASS_KEY = "contentClass",
    TAB_OPEN_TEXT_KEY = "tabOpenText",
    TAB_CLOSE_TEXT_KEY = "tabCloseText",
    ARROW_OPEN_TEXT_KEY = "arrowOpenText",
    ARROW_CLOSE_TEXT_KEY = "arrowCloseText",
    STATE_KEY = "state";   // This is a key on the node instances getData/setData rather than the plugin's ATTRS list.




var open = function(trigger, container) {

    var text,
        content,
        height;

    console.log("open", this, trigger, container);
    container._ksudata[STATE_KEY] = true;
    if (container.hasClass(TAB_FORMAT_CLASS_KEY)) {
        text = this.get(TAB_OPEN_TEXT_KEY);
    } else {
        text = this.get(ARROW_OPEN_TEXT_KEY);
    }
    content = container.one(DOT+this.get(CONTENT_CLASS_KEY));
    height = parseInt(content.getComputedStyle(HEIGHT), 10);
    height = height + 25;
    console.log(content, height);
    container.transition({
        duration: TRANSITION_DURATION,
        height: height+'px'
    });
    container.addClass(this.get(OPEN_CLASS_KEY));
    trigger.setContent(text);
};


var close = function(trigger, container) {

    var text;

    console.log("close", this, trigger, container);
    container._ksudata[STATE_KEY] = false;
    if (container.hasClass(TAB_FORMAT_CLASS_KEY)) {
        text = this.get(TAB_CLOSE_TEXT_KEY);
    } else {
        text = this.get(ARROW_CLOSE_TEXT_KEY);
    }
    container.transition({
        duration: TRANSITION_DURATION,
        height: HEIGHT_CLOSED
    });
    container.removeClass(this.get(OPEN_CLASS_KEY));
    trigger.setContent(text);
};


var toggle = function(trigger) {

    var container, state;

    console.log("Toggle", trigger);
    container = trigger.ancestor(this.get(CONTAINER_SELECTOR_KEY));

    if (!container._ksudata) {
        container._ksudata = {};
    }
    state = !container._ksudata[STATE_KEY];
    if (state) {
        open.call(this, trigger, container);
    } else {
        close.call(this, trigger, container);
    }
};


var handleToggle = function(evt) {

    console.log("handleToggle", this, arguments);
    toggle.call(this, evt.currentTarget);
};

/*
var handleChange = function(evt) {

    console.log("handleChange", this, arguments);
};
*/



/* MoreToggle class constructor */
var MoreToggle = function() {
   /*
    * Initialize the plugin infrastructure. This calls the initializer method on the new instance.
    */
    MoreToggle.superclass.constructor.apply(this, arguments);
};

/*
* Required NAME static field, to identify the class and used as an event prefix, to generate class names
* etc. (set to the class name in camel case).
*/
MoreToggle.NAME = "MoreToggle";

/*
* Required NS static field, to identify the property on the host which will, be used to refer to the
* plugin instance ( e.g. host.MoreToggle.doSomething() )
*/
MoreToggle.NS = "MoreToggle";

/*
* The attributes for the plugin.
*/
MoreToggle.ATTRS = {
        containerSelector: { value: ".ksu-more-container-tab,.ksu-more-container-arrow" },
        containerTabClass: { value: "ksu-more-container-tab" },
        containerArrowClass: { value: "ksu-more-container-arrow" },
        openClass: { value: "ksu-more-open" },
        contentClass: { value: "ksu-more-content" },
        tabOpenText: { value: "- show less" },
        tabCloseText: { value: "+ show more" },
        arrowOpenText: { value: "less <span></span" },
        arrowCloseText: { value: "more <span></span>" },
        triggerClass: { value: "ksu-more-trigger" }
 };


/* MoreToggle extends the base Plugin.Base class */
Y.extend(MoreToggle, Y.Plugin.Base, {

    /*
     * Initializer is called by the framework when the plugin is plugged into a node.
     */
    initializer: function() {
        var host = this.get(HOST);

        console.log("Initializing", this.name);

        this.prepare();
        host.delegate("click", handleToggle, DOT+this.get(TRIGGER_CLASS_KEY), this);

        console.log("done");
    },


    /**
     * Prepare a section of the DOM for more toggle functionality.
     *
     * Specifically, inspect the DOM tree looking for elements with one of the container classes,
     * but without the content class, i.e., those that haven't already been prepared.
     *
     * When found, change the HTML as needed.
     */
    prepare: function() {

        var plugin = this,
            containers,
            content,
            formatTab = this.get(CONTAINER_TAB_CLASS_KEY),
            formatArrow = this.get(CONTAINER_ARROW_CLASS_KEY),
            contentClass = this.get(CONTENT_CLASS_KEY),
            contentSelector = DOT+contentClass,
            overflowheight = 58;

        containers = Y.all(this.get(CONTAINER_SELECTOR_KEY));
        console.log(this.name, "found containers", containers);

        containers.each(function(container) {
            var format, newcontainer, text;

            //console.log("handling", container);
            content = container.one(contentSelector);

            if (content) {
                // Because the content container already exists, the HTML has already been doctored.
                //console.log("...skipping");
                return;
            }

            if (container.hasClass(formatTab)) {
                format = formatTab;
            } else {
                format = formatArrow;
            }

            newcontainer = Y.Node.create("<div></div>");
            newcontainer.setAttribute(CLASS, container.getAttribute(CLASS));
            container.replace(newcontainer);
            container.removeClass(format);
            container.addClass(contentClass);

            newcontainer.append(container);

            /*
             * If the content to too tall, add a toggle trigger.
             */
            if (container.get(REGION).height > overflowheight) {
                //console.log("adding", this);
                if (format === formatTab) {
                    text = plugin.get(TAB_CLOSE_TEXT_KEY);
                } else {
                    text = plugin.get(ARROW_CLOSE_TEXT_KEY);
                }
                //console.log(format, formatTab, plugin.get(ARROW_CLOSE_TEXT_KEY));
                newcontainer.prepend("<div class='ksu-more-toggle'>" +
                      "<div class='ksu-more-trigger'>" + text + "</div>" +
                      "<div class='ksu-more-line'></div>" +
                      "</div>");
            }
            //console.log("rearranged");

            //console.log(content.get('region'));
        });
    }


});

Y.namespace("Plugin").MoreToggle = MoreToggle;


}, '2.0.0', {"requires": ["node", "event", "plugin", "transition"]});
